var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wave__container"},[_c('canvas',{ref:"canvasRef",attrs:{"width":"600","height":"150"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }